<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="100%"
       height="100%"
       viewBox="0 0 16 16"
       xml:space="preserve"
       class="fill-current"
  >
    <g transform="matrix(1.3183,0,0,1.3183,-7.8338,-7.84931)">
        <path d="M12.001,15.5C13.232,15.5 14.28,14.67 14.701,13.5L9.301,13.5C9.722,14.67 10.77,15.5 12.001,15.5Z"
              style="fill:rgb(113,123,175);fill-rule:nonzero;"/>
    </g>
    <g transform="matrix(1.3183,0,0,1.3183,-7.8338,-7.84931)">
        <circle cx="12" cy="12" r="5.5" style="fill:none;stroke:currentColor;stroke-width:1px;"/>
    </g>
    <g transform="matrix(1.3183,0,0,1.3183,-7.8338,-7.84931)">
        <path
          d="M14.864,10.508C14.864,10.922 14.528,11.258 14.114,11.258C13.699,11.258 13.364,10.922 13.364,10.508C13.364,10.093 13.699,9.758 14.114,9.758C14.528,9.758 14.864,10.093 14.864,10.508Z"
          style="fill:currentColor;fill-rule:nonzero;"/>
    </g>
    <g transform="matrix(1.3183,0,0,1.3183,-7.8338,-7.84931)">
        <path
          d="M10.644,10.514C10.644,10.929 10.308,11.264 9.894,11.264C9.48,11.264 9.144,10.929 9.144,10.514C9.144,10.1 9.48,9.764 9.894,9.764C10.308,9.764 10.644,10.1 10.644,10.514Z"
          style="fill:currentColor;fill-rule:nonzero;"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'EmojiIcon'
}
</script>
